var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1212.37 1005.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1212.37,
    height: 1005.51
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 610.12,
    cy: 321.64,
    r: 167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.88,795.75A206.5,206.5,0,0,1,834,670.18a147.68,147.68,0,1,0-41.9,135.39Q791.89,800.68,791.88,795.75Z",
    transform: "translate(-389.88 -474.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.68,552A147.68,147.68,0,0,0,1166,670.18a206.52,206.52,0,0,1,42.13,125.57q0,4.93-.23,9.82A147.62,147.62,0,1,0,1310.68,552Z",
    transform: "translate(-389.88 -474.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.46,1225.67V1155.8a164.68,164.68,0,0,0-164.68-164.68H873.22A164.68,164.68,0,0,0,708.54,1155.8v258a9.66,9.66,0,0,0,7.7,9.47C791.7,1438.8,884.88,1448,985.73,1448c114.13,0,218.45-11.78,298.35-31.24a9.65,9.65,0,0,0,7.38-9.39v-181.7Z",
    transform: "translate(-389.88 -474.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.42,1155.8A205.79,205.79,0,0,1,860.71,950.39q-4-3.63-7.87-7.48a207.71,207.71,0,0,1-46.43-70.48c-1.66-.06-3.34-.1-5-.1H577.25a145.58,145.58,0,0,0-145.58,145.58v228a8.55,8.55,0,0,0,6.81,8.38c64.38,13.28,143.36,21.31,228.94,21.85Z",
    transform: "translate(-389.88 -474.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.75,872.33H1198.61c-1.68,0-3.36,0-5,.09a207.51,207.51,0,0,1-46.43,70.49q-3.86,3.86-7.87,7.48a205.79,205.79,0,0,1,193.29,205.41v120c87.34-2.08,166.74-12,229.23-27.2a8.54,8.54,0,0,0,6.52-8.31V1017.91A145.58,145.58,0,0,0,1422.75,872.33Z",
    transform: "translate(-389.88 -474.11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.4d6f0713.svg";
export { ForwardRef as ReactComponent };